import { addToRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SharePointVideoPreviewUrlLoadFulfilledAction } from '../../domains/sharePointVideoPreviewUrls/actions.types';

import { SharePointVideoPreviewUrls } from './types';

const initialState: SharePointVideoPreviewUrls = {};

const reducer: Reducer<SharePointVideoPreviewUrls, SharePointVideoPreviewUrlLoadFulfilledAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SHAREPOINT_VIDEO_PREVIEW_URL.LOAD_FULFILLED': {
      return addToRecord(state, action.payload.id, {
        url: action.payload.url,
        authenticationTenantId: action.payload.authenticationTenantId,
        authenticationOfficeUserId: action.payload.authenticationOfficeUserId,
      });
    }
    default:
      return state;
  }
};

export default reducer;
